import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { initialize, clearSubmitErrors } from 'redux-form';
import { loadReportChildren, exportReportChildren, REPORT_CHILDREN_REQUEST, REPORT_CHILDREN_SUCCESS, REPORT_CHILDREN_FAILURE } from './actions';
import { Tabs, Tab } from 'react-bootstrap';
import List from './List';
import Filter from './Filter';
import Summary from './Summary';
import { loadUnpagedGrades } from '../../grades/actions';
import ReduxBlockUi from 'react-block-ui/redux';
import { i18n } from '../../../common/services/globalize';

class ReportChildren extends Component {
	constructor(props) {
		super(props);
		this.handleFilterSubmit = this.handleFilterSubmit.bind(this);
		this.handleListEvent = this.handleListEvent.bind(this);
		this.handleTermSelected = this.handleTermSelected.bind(this);
		this.state = {};
	}

	componentDidMount() {
		this.loadGrades();

		const { type, reportOptions, pagination: { filter, sortKey, sortDirection, pageNumber, pageSize } } = this.props;

		if (reportOptions.filterByPeriod || (filter && filter.termId)) {
			this.props.loadEntities({ ...filter, sortKey, sortDirection, pageSize, pageNumber }, type);
			this.props.initializeFilter(filter);
			if (filter && filter.termId) {
				this.setState({ [type]: { termId: filter.termId } });
			}
		}
	}

	componentWillReceiveProps(nextProps) {
		const { type } = nextProps;
		const currentType = this.props.type;

		let filter = nextProps.pagination.filter || {};
		const { sortKey, sortDirection, pageNumber, pageSize } = nextProps.pagination;

		if (type !== currentType) {
			// reload data
			this.props.loadEntities({ ...filter, sortKey, sortDirection, pageSize, pageNumber }, type);
		}
	}

	handleTermSelected(termId) {
		const type = this.props.type;
		const stateByType = this.state[type];

		// trigger filter on initial load when Active Term is selected by default in the dropdown
		if (!stateByType || stateByType.termId === null) {
			const { filter = {} } = this.props.pagination;
			if (!filter.termId) {
				filter.termId = termId;
				this.props.initializeFilter(filter);
			}

			this.loadData({ ...this.props.pagination, filter: { ...filter } });
		}
		this.setState({ [type]: { termId } });
	}

	handleFilterSubmit(options) {
		const { isExport, ...filter } = options;
		const { sortKey, sortDirection, pageNumber, pageSize } = this.props.pagination;
		this.loadData({ filter, sortKey, sortDirection, pageNumber: 1, pageSize });

		if (isExport)
			this.exportData(filter);
	}

	handleListEvent(listPagination) {
		const { filter } = this.props.pagination;
		this.loadData({ filter, ...listPagination });
	}

	loadData({ filter, sortKey, sortDirection, pageNumber, pageSize }) {
		this.props.clearSubmitErrors();
		this.props.loadEntities({ ...filter, sortKey, sortDirection, pageSize, pageNumber }, this.props.type);
	}

	loadGrades() {
		const { loadUnpagedGrades } = this.props;
		loadUnpagedGrades();
	}

	exportData(filter) {
		this.props.exportReportChildren(filter, this.props.type);
	}

	render() {
		const { t, reportChildrenSummary, type, reportOptions, grades, franchisor } = this.props;

		return (

			<div>
				<Filter onSubmit={this.handleFilterSubmit} onTermSelected={this.handleTermSelected}
					grades={grades} reportOptions={reportOptions} loading={this.props.pagination.loading || this.props.export.loading} />
				<Tabs defaultActiveKey={reportOptions.requiredCenter ? 1 : 2} id='report-parent-tabs'>
					<Tab eventKey={1} title={t('ReportChildren_Tab_Details')}>
						<List data={this.props.data} onFetchData={this.handleListEvent} {...this.props.pagination} title={reportOptions.titleDetails} reportOptions={reportOptions} requireAddress={franchisor.requireAddress} requirePostcode={franchisor.requirePostcode} requireChildSchool={franchisor.requireChildSchool} />
					</Tab>
					{!reportOptions.requiredCenter && <Tab eventKey={2} title={t('ReportChildren_Tab_Summary')}>
						<ReduxBlockUi block={REPORT_CHILDREN_REQUEST} unblock={[REPORT_CHILDREN_SUCCESS, REPORT_CHILDREN_FAILURE]}>
							<Summary title={reportOptions.titleSummary} data={reportChildrenSummary} reportType={type} />
						</ReduxBlockUi>
					</Tab>}
				</Tabs>

			</div>
		);
	}
}

const mapStateToProps = (state, ownProps) => {
	const type = ownProps.match.path.substr(ownProps.match.path.lastIndexOf('/') + 1);

	const {
		pagination,
		exports,
		entities: { reportChildrenDetails, grades, reportChildrenSummary },
		configuration: { franchisor }
	} = state;

	const reportChildrenDetailsPagination = pagination.reportChildrenDetails[type] || { ids: [], pageNumber: 1, pageSize: 10 };
	let summary = reportChildrenDetailsPagination.ids.length > 0 ? Object.values(reportChildrenSummary).filter((center) => center.type == type) : {};
	const reportChildrenDetailsExport = exports.reportChildrenDetails.all || {};

	// TODO: use ownProps to set report options
	let reportOptions = {
		filterByTerm: (type === 'paidForTerm') || (type === 'enrolledForTrialLesson') || (type === 'enrolledForTrialLessonNotPaidTerm') ||
			(type === 'newChildrenForTerm') || (type === 'childrenByGradeForTerm') || (type === 'paidPrevTerm'),
		filterByGrade: (type === 'paidForTerm') || (type === 'paidPrevTerm') || (type === 'enrolledForTrialLesson') ||
			(type === 'enrolledForTrialLessonNotPaidTerm') || type === 'childrenByGradeForTerm',
		filterByPeriod: (type === 'chosenCenterNotBooked' || type === 'childrenWithoutMedicalInformation'),
		showIsAttended: type === 'enrolledForTrialLesson',
		showLessonInfo: (type === 'paidForTerm') || (type === 'enrolledForTrialLesson'),
		requiredCenter: type === 'childrenWithoutMedicalInformation' || (type === 'paidPrevTerm'),//when required center not show summary by centers
		showPaymentType: type === 'paidForTerm',
		showGrage: type === 'childrenByGradeForTerm',
		showEnrolled: type === 'enrolledForTrialLesson',
		showTotalAmount: type === 'newChildrenForTerm',
		showLessonNumber: type === 'childrenByGradeForTerm',
		hideParentDetails: type === 'childrenByGradeForTerm',
		showComparisonTerm: type === 'paidPrevTerm',
		termLabel: type === 'paidPrevTerm' ? i18n.t('ReportChildren_NewTerm') : i18n.t('ReportChildren_Term'),
		// the parent's center is the one they last viewed in the portal; only this report says so
		centerLabel: type === 'chosenCenterNotBooked' ? i18n.t('ReportChildren_LastViewedCenter') : i18n.t('ReportChildren_Center'),
		titleSummary: type === 'paidForTerm' ? i18n.t('Report_PaidForTermSummaryTitle') : '',
		titleDetails: type === 'paidForTerm' ? i18n.t('Report_PaidForTermDetailsTitle') : ''
	};

	return {
		data: reportChildrenDetailsPagination.ids.map(id => reportChildrenDetails[id]),
		pagination: reportChildrenDetailsPagination,
		grades: grades,
		reportChildrenSummary: summary,
		type,
		reportOptions,
		franchisor,
		export: reportChildrenDetailsExport
	};
};

export default connect(mapStateToProps, {
	loadEntities: loadReportChildren,
	exportReportChildren,
	loadUnpagedGrades,
	clearSubmitErrors: () => clearSubmitErrors('reportChildrenDetailsFilter'),
	initializeFilter: (data, fields) => initialize('reportChildrenDetailsFilter', data, fields)
})(withTranslation()(ReportChildren));